import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { TopicsComponent } from '../components/topics.component';
import { topics } from '../../../../../../redux/chapter/topics/action';
import { selectTopicsQueryItems } from '../../../../../../redux/chapter/topics/selector';
import { chapter } from '../../../../../../redux/chapter/chapters/action';
import { selectChapterListItems } from '../../../../../../redux/chapter/chapters/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { settings } from '../../../../../../redux/settings/actions';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import UploadFiles from '../../../../../../models/UploadFile';

const Topic = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const topicsQuery = useSelector(selectTopicsQueryItems);
  const chaptersItems = useSelector(selectChapterListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const libraryData = useSelector(selectListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
  const [openConfirmationCoverFile, setOpenConfirmationCoverFile] = React.useState(false);
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [openImageFile, setOpenImageFile] = useState<any>([]);

  const handleClose = () => {
    if (openConfirmationLogoFile) {
      setOpenConfirmationLogoFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }


  const [selectedTopics, setSelectedTopics] = useState<any>({
    "Name": "",
    "DisplayOrder": 0,
    "CommunityId": 0

  });

  const fetchForumGroupsQueryById = () => {
    dispatch(topics.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/query`,
      entity: 'topics',
      jsonData: {
        Context: {},
        Records: [
          {

            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTopics({ ...selectedTopics, [field]: event });
  }
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }
  useEffect(() => {
    dispatch(chapter.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapters/list`,
      entity: 'chapter',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "Id": 0
          }
        ],




      }
    })).then(() => {
      if (parmas?.id > 0) {
        fetchForumGroupsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedTopics(topicsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const TopicsData = {
      "Id": selectedTopics?.Id || 0,
      "CommunityChapterId": selectedTopics?.CommunityChapterId,
      "TopicTypeId": selectedTopics?.TopicTypeId,
      "Subject": selectedTopics?.Subject,
      "LogoUrl": selectedTopics?.LogoUrl,
      "CoverImageUrl": selectedTopics?.CoverImageUrl,
      "MediaMappings": {
        "MediaFiles": [],
        "Templates": []
      }
    }
    if (parmas?.id > 0) {
      await dispatch(topics.resetAction({ actionType: 'update' }))
      await dispatch(topics.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics`,
        entity: 'topics',
        jsonData: {
          Context: {},
          Records: [
            TopicsData
          ]
        }

      })).then(() => {
        back();
      });
    } else {
      await dispatch(topics.resetAction({ actionType: 'create' }))
      await dispatch(topics.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics`,
        entity: 'topics',
        jsonData: {
          Context: {},
          Records: [
            TopicsData
          ]
        }

      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/onesp/chapters/feeds');
  }

  const changeLogoImage = (templateField: any, fileType: any, selectedCommunity: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationLogoFile(true)
    setOpenImageFile({
      currentFileSrc: selectedCommunity?.LogoUrl || templateField,
      folder: 'chaptertopic',
      type: fileType
    })
  }

  const CoverImageUrl = (templateField: any, fileType: any, selectedCommunity: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationCoverFile(true)
    setOpenImageFile({
      currentFileSrc: selectedCommunity?.CoverImageUrl || templateField,
      folder: 'communitychapter',
      type: fileType
    })
  }

  const handleLogoSubmit = (data: any) => {
    const logoData = {
      LogoUrl: data
    }
    setSelectedTopics({ ...selectedTopics, ...logoData })
  }

  const handleCoverSubmit = (data: any) => {
    const coverImageUrl = {
      CoverImageUrl: data
    }
    setSelectedTopics({ ...selectedTopics, ...coverImageUrl })
  }

  return (
    <>
      {getUploadFiles == 'open' && openConfirmationLogoFile &&
        <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
          folder={openImageFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handleLogoSubmit}
          type={openImageFile?.type}
          ownerId={parmas?.id}
        />
      }

      {getUploadFiles == 'open' && openConfirmationCoverFile &&
        <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
          folder={openImageFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handleCoverSubmit}
          type={openImageFile?.type}
          ownerId={parmas?.id}
        />
      }
      {topicsQuery?.isLoading ? <PageLoader /> :
        <TopicsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedTopics={selectedTopics}
          back={back}
          handleFormSubmit={handleFormSubmit}
          chapters={chaptersItems?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          libraryData={libraryData?.result?.ChapterTopicType}
          changeLogoImage={changeLogoImage}
          changeCoverImage={CoverImageUrl}
        />
      }
    </>
  );
}

export default Topic;
